import { render, staticRenderFns } from "./ValorPrevisto.vue?vue&type=template&id=639f7fb8&"
import script from "./ValorPrevisto.vue?vue&type=script&lang=js&"
export * from "./ValorPrevisto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports